"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const group_multi_format_1 = require("../group-multi-format");
const plain_text_format_1 = require("./plain-text-format");
// group all the multi-format concerning plain data
const group = new group_multi_format_1.default([new plain_text_format_1.default()]);
exports.default = group;
